import React from 'react';

import FarmFeed from '../FarmFeed/FarmFeed';
import FarmGallery from '../FarmGallery/FarmGallery';
import FarmConditions from '../FarmCondition/FarmCondition';
import FarmInfo from '../FarmInfo/FarmInfo';
import FarmWarehouse from '../FarmWarehouse/FarmWarehouse';
import FarmDocument from '../FarmDocument/FarmDocument';

const components = {
  compA: FarmFeed,
  compB: FarmGallery,
  compC: FarmConditions,
  compD: FarmInfo,
  compE: FarmDocument,
  compF: FarmWarehouse
};

const DynamicSections = ({ view, data }) => {
  const SelectedOrder = components[view];
  return <SelectedOrder data={data} />;
};

export default DynamicSections;
